(function () {
  var SECTION_SELECTOR = [
    '.section-featured-collection-v3--hot-deals-card',
    '.section-featured-collection-v3--v2-slider',
    '.section-featured-collection-v2',
    '.ubiquiti-hot-deals',
    '.ubiquiti-best-sellers',
    '.ubiquiti-recently-released',
    '.business-hub-office-essentials-section',
    '[data-section-type="related-products"]',
    '[data-section-type="featured-collection"]'
  ].join(', ');
  var boundSections = new WeakSet();

  function getSlides(section, scope) {
    scope = scope || section;
    var sliderList = scope.querySelector('.tns-slider') || scope.querySelector('.slider-list');
    if (!sliderList) return [];

    return Array.prototype.slice.call(sliderList.children).filter(function (slide) {
      return slide.classList.contains('slider-item') && !slide.classList.contains('tns-slide-cloned');
    });
  }

  function getSyncScope(section, panel) {
    if (panel) return panel;
    if (!section.classList.contains('business-hub-office-essentials-section')) return section;
    return section.querySelector('[data-oe-panel]:not([hidden])') || section.querySelector('[data-oe-panel]') || section;
  }

  function measureSlide(slide) {
    if (slide.classList.contains('business-hub-oe__slide-pair')) {
      return slide.offsetHeight;
    }

    var card = slide.querySelector('.product-card--v2');
    if (card) return card.offsetHeight;
    var wrap = slide.querySelector('product-card');
    if (wrap) return wrap.offsetHeight;
    return slide.offsetHeight;
  }

  function resetSlideHeights(slides) {
    slides.forEach(function (slide) {
      slide.style.minHeight = '';
      slide.querySelectorAll('product-card').forEach(function (wrap) {
        wrap.style.minHeight = '';
      });
      slide.querySelectorAll('.product-card--v2').forEach(function (card) {
        card.style.minHeight = '';
      });
    });
  }

  function measureCardPair(card) {
    if (!card) return 0;
    return card.offsetHeight;
  }

  function applyMinHeight(targets, heightPx) {
    if (!heightPx || heightPx <= 0) return;
    var height = heightPx + 'px';
    targets.forEach(function (target) {
      if (!target) return;
      target.style.minHeight = height;
    });
  }

  function syncPairedSlides(slides) {
    var topRows = [];
    var bottomRows = [];

    slides.forEach(function (slide) {
      var wraps = slide.querySelectorAll('product-card');
      if (wraps[0]) {
        topRows.push({
          wrap: wraps[0],
          card: wraps[0].querySelector('.product-card--v2')
        });
      }
      if (wraps[1]) {
        bottomRows.push({
          wrap: wraps[1],
          card: wraps[1].querySelector('.product-card--v2')
        });
      }
    });

    function maxRowHeight(rows) {
      var max = 0;
      rows.forEach(function (row) {
        max = Math.max(max, measureCardPair(row.card), row.wrap ? row.wrap.offsetHeight : 0);
      });
      return max;
    }

    function stretchRows(rows, heightPx) {
      rows.forEach(function (row) {
        applyMinHeight([row.wrap, row.card], heightPx);
      });
    }

    var topHeight = maxRowHeight(topRows);
    var bottomHeight = maxRowHeight(bottomRows);
    stretchRows(topRows, topHeight);
    stretchRows(bottomRows, bottomHeight);

    if (topHeight <= 0 && bottomHeight <= 0) return;

    slides.forEach(function (slide) {
      var gap = 16;
      var style = window.getComputedStyle(slide);
      var parsedGap = parseFloat(style.gap) || parseFloat(style.rowGap);
      if (!Number.isNaN(parsedGap)) gap = parsedGap;
      slide.style.minHeight = topHeight + bottomHeight + gap + 'px';
    });
  }

  function syncSection(section, panel) {
    var scope = getSyncScope(section, panel);
    var slides = getSlides(section, scope);
    if (!slides.length) return;

    resetSlideHeights(slides);

    if (slides[0] && slides[0].classList.contains('business-hub-oe__slide-pair')) {
      syncPairedSlides(slides);
      return;
    }

    var max = 0;
    slides.forEach(function (slide) {
      max = Math.max(max, measureSlide(slide));
    });

    if (max <= 0) return;

    var height = max + 'px';
    slides.forEach(function (slide) {
      slide.style.minHeight = height;
      var wrap = slide.querySelector('product-card');
      var card = slide.querySelector('.product-card--v2');
      if (wrap) wrap.style.minHeight = height;
      if (card) card.style.minHeight = height;
    });
  }

  function scheduleSync(section, panel) {
    requestAnimationFrame(function () {
      syncSection(section, panel);
      requestAnimationFrame(function () {
        syncSection(section, panel);
      });
    });
    window.setTimeout(function () {
      syncSection(section, panel);
    }, 150);
    window.setTimeout(function () {
      syncSection(section, panel);
    }, 500);
  }

  function bindTnsEvents(section, sliderComponent, run) {
    var instance = sliderComponent && sliderComponent.slider;
    if (!instance || !instance.events || typeof instance.events.on !== 'function') return;

    ['indexChanged', 'transitionEnd', 'newBreakpointStart'].forEach(function (eventName) {
      instance.events.on(eventName, run);
    });
  }

  function watchImages(section, run) {
    section.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', run, { once: true });
      }
    });
  }

  function bindSliderComponent(section, sliderComponent, run) {
    var container = sliderComponent && sliderComponent.querySelector('.js-slider-container');
    if (!container) {
      run();
      return;
    }

    if (container.classList.contains('slider-initialized')) {
      bindTnsEvents(section, sliderComponent, run);
      run();
      return;
    }

    var observer = new MutationObserver(function () {
      if (!container.classList.contains('slider-initialized')) return;
      observer.disconnect();
      setTimeout(function () {
        bindTnsEvents(section, sliderComponent, run);
        run();
      }, 50);
    });
    observer.observe(container, { attributes: true, attributeFilter: ['class'] });
  }

  function bindSection(section) {
    if (boundSections.has(section)) return;
    boundSections.add(section);

    var run = function () {
      scheduleSync(section);
    };

    watchImages(section, run);

    var sliderComponents = section.classList.contains('business-hub-office-essentials-section')
      ? Array.prototype.slice.call(section.querySelectorAll('slider-component'))
      : [section.querySelector('slider-component')].filter(Boolean);

    if (!sliderComponents.length) {
      run();
    } else {
      sliderComponents.forEach(function (sliderComponent) {
        bindSliderComponent(section, sliderComponent, run);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(run, 150);
    });
  }

  function init(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      bindSection(section);
    });
  }

  document.addEventListener('product-card-carousel:resync', function (event) {
    var section = event.detail && event.detail.section;
    var panel = event.detail && event.detail.panel;
    if (!section) return;
    if (!boundSections.has(section)) {
      bindSection(section);
    }
    scheduleSync(section, panel);
  });

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  window.addEventListener('load', function () {
    init();
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      scheduleSync(section);
    });
  });
})();
